export class GzzAddress {

  CityId: string;
  CityName: string;
  StreetId: string;
  StreetName: string;
  HouseNumber: string;
  Entrance: string;
  AppartmentNumber: string;
  ZipCode: string;
  Postbox: string;

  constructor(address) {

    if (address) {

      if (address.cityId) {
        this.CityId = address.cityId.Code;
        this.CityName = address.cityId.Description;
      }
      if (address.entrance) {
        this.Entrance = address.entrance.text;
      }
      this.HouseNumber = address.houseNumber;
      this.AppartmentNumber = address.appartmentNumber;
      this.ZipCode = address.zipCode;
      this.Postbox = address.postbox;

      if (address.streetId && address.streetId.Street_code != null)
        this.StreetId = address.streetId.Street_code;

      //in case the user entered a street thats not in the list
      else {
        this.StreetId = '9999';
        this.StreetName = address.streetId;
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/models/general/GzzAddress.ts